<template>
  <div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
        <c-table
          ref="grid1"
          title="감사기준"
          tableId="grid1"
          :columnSetting="false"
          :isFullScreen="false"
          :usePaging="false"
          :filtering="false"
          :hideBottom="true"
          :columns="grid1.columns"
          :data="grid1.data"
          @rowClick="rowClick"
        >
        </c-table>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
        <c-table
          ref="grid2"
          title="감사기준별 감사항목"
          tableId="grid2"
          :columnSetting="false"
          :isFullScreen="false"
          :usePaging="false"
          :filtering="false"
          :hideBottom="true"
          :columns="grid2.columns"
          :data="grid2.data"
        >
          <template slot="table-button">
            <div>
              <q-btn-group>
                <c-btn label="항목 추가" icon="add" @btnClicked="addrow" />
                <c-btn v-if="editable" label="저장" icon="save" />
                <c-btn label="삭제" icon="remove" />
              </q-btn-group>
            </div>
          </template>
        </c-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'auth-group',
  data() {
    return {
      searchParam: {
        plantCd: null,
        keyword: '',
        useFlag: 'Y',
      },
      grid1: {
        columns: [
          {
            name: 'col1',
            field: 'col1',
            label: '평가기준항목',
            align: 'left',
            sortable: false,
          },
        ],
        data: [],
      },
      grid2: {
        columns: [
          {
            name: 'col1',
            field: 'col1',
            label: '감사항목',
            align: 'left',
            type: 'textarea',
            style: 'width: 60%',
            sortable: false,
          },
          {
            name: 'col2',
            field: 'col2',
            label: '비고',
            align: 'left',
            type: 'textarea',
            sortable: false,
          },
          {
            name: 'col3',
            field: 'col3',
            label: '정렬순서',
            align: 'center',
            type: 'text',
            style: 'width: 100px',
            sortable: false,
          },
        ],
        data: [],
      },
      editable: true,
      searchUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.getList();
    },
    getList() {
      this.grid1.data = [
        {
          col1: '안전경영과 근로자참여',
          col2: '1',
        },
        {
          col1: '공정안전자료',
          col2: '2',
        },
        {
          col1: '공정위험성평가',
          col2: '3',
        },
        {
          col1: '안전운전 지침과 절차',
          col2: '4',
        },
        {
          col1: '설비의 점검 검사 보수계획, 유지계획 및 지침',
          col2: '5',
        },
        {
          col1: '안전작업허가 및 절차',
          col2: '6',
        },
        {
          col1: '도급업체 안전관리',
          col2: '7',
        },
        {
          col1: '공정운전에 대한 교육훈련',
          col2: '8',
        },
        {
          col1: '가동전 점검지침',
          col2: '9',
        },
        {
          col1: '변경요소 관리계획',
          col2: '10',
        },
        {
          col1: '자체감사',
          col2: '11',
        },
        {
          col1: '안전사고조사 지침',
          col2: '12',
        },
        {
          col1: '비상조치계획',
          col2: '13',
        },
        {
          col1: '현장확인',
          col2: '14',
        },
      ]
    },
    rowClick(row) {
      if (row.col2 == '1') {
        this.grid2.data = [
          {col1: '14-01 회사의 경영목표로 안전·보건을 우선적으로 강조하고 실천하는가? '},
          {col1: '14-02 공정안전관리(PSM) 12개 요소의 내용과 목적을 정확하게 이해하고 있는가?'},
          {col1: '14-03 공정위험성평가, 변경요소관리, 안전사고 및 자체감사 결과의 개선권고사항 및 처리현황을 정기적으로 확인하고 있는가?'},
          {col1: '14-04 사업장 내·외부 PSM 관련 안전·보건 교육훈련계획을 승인하고 그 결과를 보고 받는가?'},
          {col1: '14-04 사업장 내·외부 PSM 관련 안전·보건 교육훈련계획을 승인하고 그 결과를 보고 받는가?'},
        ]
      } else if (row.col2 == '2') {
        this.grid2.data = [
          {col1: '1-01 사업장에서 사용하고 있는 유해위험물질의 목록이 누락된 물질 없이 정확히 작성되어 있는가?'},
          {col1: '1-02 사업장에서 사용하고 있는 유해·위험물질에 대한 물질안전보건자료(MSDS)의 작성, 비치, 교육, 경고표지 등이 적절하게 되었는가?'},
          {col1: '1-03 유해·위험설비 및 목록(동력기계, 장치 및 설비, 배관, 안전밸브 등)이 정확히 작성되어 있으며 현장과 일치하는가?'},
          {col1: '1-04 공정흐름도(PFD), 공정배관계장도(P&ID), 유틸리티흐름도(UFD)가 정확히 작성되어 있으며 현장과 일치하는가?'},
          {col1: '1-05 건물·설비의 배치도(가스누출감지경보기 설치계획, 국소배기장치 설치계획 등)가 정확히 작성되어 있으며 현장과 일치하는가?'},
        ]
      } else {
        this.grid2.data = [];
      }
    },
  }
};
</script>
